module.exports = __webpack_public_path__ + "static/img/9bg_8.228dd6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/9bg_8.png
// module id = 780
// module chunks = 1